import { oz } from '@weft/utils';

export const EventDataSchema = oz.record(oz.string(), oz.any());
export type EventData = oz.infer<typeof EventDataSchema>;
